/**
 * 풀어야 할 문제 목록을 가져온다. `GET /app/learning/question`.
 *
 * 홈 화면 학습 진입 카드(`src/components/home/StudentHome.tsx`), 문제 풀이 진입 화면
 * (`pages/problem/index.tsx`)에서 쓴다. 로그인한 학생에게 배정된 문제라 `axiosInstance` 를 쓴다.
 *
 * 주의: 이 파일은 `pages/api/` 안에 있지만 서버에서 도는 코드가 아니다.
 */
import api from "../axiosInstance";

/** @returns `BaseResponse.result.questionInfoList`(문제 배열). 실패하면 undefined(예외를 던지지 않고 콘솔에만 남긴다). */
export async function fetchProblems() {
  try {
    const res = await api.get("/app/learning/question");

    return res.data.result.questionInfoList;
  } catch (error) {
    // 에러 발생 시 메시지 출력
    console.error("Error fetching problems:", error);
  }
}
